export default {
  data: () => ({
    translations: {
      title_points: {
        el: 'Εμφάνιση Πόντων Χρηστών',
        en: 'Show User Points',
        it: 'Mostra punti utente',
      },
      title_cashback: {
        el: 'Εμφάνιση Cashback Χρηστών',
        en: 'Show User Cashback',
        it: 'Mostra cashback utente',
      },
      showUser_points: {
        el: 'Προβολή των πόντων των χρηστών στην εφαρμογή',
        en: 'Show user points in the app',
        it: "Visualizzare i punti degli utenti nell'app",
      },
      showUser_cashback: {
        el: 'Προβολή του cashback των χρηστών στην εφαρμογή',
        en: 'Show user cashback in the app',
        it: "Visualizzare il cashback degli utenti nell'app",
      },
      yes: {
        el: 'Ναι',
        en: 'Yes',
        it: 'Sì',
      },
      no: {
        el: 'Όχι',
        en: 'No',
        it: 'No',
      },
    },
  }),
};
